import { createFeature, createReducer, on } from '@ngrx/store';
import { ReceiptModeModel } from '@shared/data-access/models';
import { ReceiptModeAction } from '../actions';

export const featureName = 'receiptMode';

export interface ReceiptModeState {
  item: ReceiptModeModel | null;
}

export const initialState: ReceiptModeState = {
  item: null,
};

export const receiptModeFeature = createFeature({
  name: featureName,
  reducer: createReducer(
    initialState,
    on(ReceiptModeAction.loadItemSuccess, (state, { item }) => ({ ...state, item }))
  ),
});

export const { name, reducer } = receiptModeFeature;
